import { reactive, computed } from "@vue/composition-api"
import vuetify from '../start/init/vuetify/'
import Chroma from 'chroma-js'
import waitForActively from '@iez/lib/wait-for-actively/'

const syncRootDomElement = ({ isDark }) => {
  const value = isDark ? `#000` : `#fff`
  waitForActively({
    predicate: () => document.querySelector(`.v-main`)
  }).then(vMain => {
    vMain
      .style
      .background = value
  })
}

export const theme = reactive({
  isDarkLocally: false,
  dark: computed({
    get: () => vuetify.framework.theme.dark,
    set: value => {
      onChangeTriggers.forEach(process => process())
      if (value) {
        document.body.classList.add(`iez--dark`)
      } else {
        document.body.classList.remove(`iez--dark`)
      }
      if (!theme.isDarkLocally) {
        if (value) {
          localStorage.setItem(`dark`, true)
        } else {
          localStorage.removeItem(`dark`)
        }
      }
      syncRootDomElement({ isDark: value })
      vuetify.framework.theme.dark = value
      window.ReactNativeWebView?.postMessage(JSON.stringify({
        nativeMethodName: `setIsDark`,
        params: value
      }))
    }
  }),
  darkLabel: computed(
    () =>
    vuetify.framework.theme.dark
      ? `dark`
      : `light`
  ),
  primary: {
    color: computed({
      get: () => vuetify.framework.theme.themes.light.primary,
      set: value => {
        vuetify.framework.theme.themes.light.primary = value
        vuetify.framework.theme.themes.dark.primary = value
      }
    })
  },
  background: {
    color: computed(
      () => Chroma(
        vuetify.framework.theme.themes.light.primary
      ).set('hsl.s', .2)
      .set('hsl.l', theme.dark ? .2 : .8)
      .hex()
    )
  },
  backgroundLight: {
    color: computed(
      () => Chroma(
        vuetify.framework.theme.themes.light.primary
      ).set('hsl.s', .1)
      .set('hsl.l', theme.dark ? .06 : .96)
      .hex()
    )
  },
  indicator: {
    color: computed(
      () => Chroma(
        vuetify.framework.theme.themes.light.primary
      ).set('hsl.s', .2)
      .set('hsl.l', theme.dark ? .2 : .8)
      .hex()
    )
  }
})

const onChangeTriggers = []
export const addThemeChangeTrigger = process => {
  onChangeTriggers.push(process)
}

theme.dark = !!localStorage.getItem(`dark`)
